import React, {useState} from 'react';
import './index.css';
import Container from '../layout/container';
import {Link} from 'react-router-dom';
import useWindowWidth from '../hooks/useWindowWidth';
import classnames from 'classnames';

export default function Header() {
  const width = useWindowWidth();
  const [showMenu, setShowMenu] = useState(false);
  const landingUrl = '/2021perfectstickercontest/landing';
  const joinUrl = '/2021perfectstickercontest/join';
  const prizeUrl = '/2021perfectstickercontest/prize';
  const galleryUrl = '/2021perfectstickercontest/gallery';
  const winnerUrl = '/2021perfectstickercontest/winner';

  const landingIcon =
    window.location.href.indexOf(landingUrl) !== -1
      ? require('../../assets/images/ycp/ico_stickercontest_top_home_s.png')
      : require('../../assets/images/ycp/ico_stickercontest_top_home.png');
  const prizeIcon =
    window.location.href.indexOf(prizeUrl) !== -1
      ? require('../../assets/images/ycp/ico_stickercontest_top_prize_s.png')
      : require('../../assets/images/ycp/ico_stickercontest_top_prize.png');
  const joinIcon =
    window.location.href.indexOf(joinUrl) !== -1
      ? require('../../assets/images/ycp/ico_stickercontest_top_join_s.png')
      : require('../../assets/images/ycp/ico_stickercontest_top_join.png');
  const galleryIcon =
    window.location.href.indexOf(galleryUrl) !== -1
      ? require('../../assets/images/gallery/ico_stickercontest_top_submissions_s.png')
      : require('../../assets/images/gallery/ico_stickercontest_top_submissions.png');
  const winnerIcon =
    window.location.href.indexOf(winnerUrl) !== -1
      ? require('../../assets/images/winner/ico_stickercontest_top_winners_s.png')
      : require('../../assets/images/winner/ico_stickercontest_top_winners.png');
  return (
    <div className="pf-ycp__header">
      <Container
        style={{display: 'flex', alignItems: 'center', position: 'relative'}}
      >
        <a href="https://www.perfectcorp.com/zh-tw/consumer" target="_blank">
          <img
            className="pf-header__logo"
            alt=""
            src={require('../../assets/images/ycp/ico_stickercontest_pflogo.png')}
          />
        </a>
        <div className="pf-header__right">
          {(width > 800 || window.location.href.indexOf(landingUrl) !== -1) && (
            <Link
              to={landingUrl}
              className={classnames({
                'pf-header__icon': true,
                'pf-header__icon-hover':
                  window.location.href.indexOf(landingUrl) !== -1,
              })}
            >
              <img alt="" src={landingIcon} />
              活動首頁
            </Link>
          )}
          {(width > 800 || window.location.href.indexOf(prizeUrl) !== -1) && (
            <Link
              to={prizeUrl}
              className={classnames({
                'pf-header__icon': true,
                'pf-header__icon-hover':
                  window.location.href.indexOf(prizeUrl) !== -1,
              })}
            >
              <img alt="" src={prizeIcon} />
              獎項 & 參賽辦法
            </Link>
          )}
          {(width > 800 || window.location.href.indexOf(joinUrl) !== -1) && (
            <Link
              to={joinUrl}
              className={classnames({
                'pf-header__icon': true,
                'pf-header__icon-hover':
                  window.location.href.indexOf(joinUrl) !== -1,
              })}
            >
              <img alt="" src={joinIcon} />
              我要參賽
            </Link>
          )}
          {(width > 800 || window.location.href.indexOf(galleryUrl) !== -1) && (
            <Link
              to={galleryUrl}
              className={classnames({
                'pf-header__icon': true,
                'pf-header__icon-hover':
                  window.location.href.indexOf(galleryUrl) !== -1,
              })}
            >
              <img alt="" src={galleryIcon} />
              入圍作品
            </Link>
          )}
          {(width > 800 || window.location.href.indexOf(winnerUrl) !== -1) && (
            <Link
              to={winnerUrl}
              className={classnames({
                'pf-header__icon': true,
                'pf-header__icon-hover':
                  window.location.href.indexOf(winnerUrl) !== -1,
              })}
            >
              <img alt="" src={winnerIcon} />
              得獎作品
            </Link>
          )}
          {width <= 800 && (
            <img
              style={{marginLeft: '15px', cursor: 'pointer'}}
              alt=""
              src={require('../../assets/images/ycp/menu_white.svg')}
              onClick={() => setShowMenu(!showMenu)}
            />
          )}
        </div>
      </Container>
      {showMenu && (
        <div>
          <div className="pf-mobile_menu-popupmenu__overlay">
            <div className="pf-mobile_menu-block">
              <Link
                to={landingUrl}
                className={classnames({
                  'pf-mobile_menu-item': true,
                  'pf-mobile_menu-item-hover':
                    window.location.href.indexOf(landingUrl) !== -1,
                })}
                onClick={() => setShowMenu(false)}
              >
                <img alt="" src={landingIcon} />
                活動首頁
              </Link>
              <div className="pf-mobile_menu-item-divider" />
              <Link
                to={prizeUrl}
                className={classnames({
                  'pf-mobile_menu-item': true,
                  'pf-mobile_menu-item-hover':
                    window.location.href.indexOf(prizeUrl) !== -1,
                })}
                onClick={() => setShowMenu(false)}
              >
                <img alt="" src={prizeIcon} />
                獎項 & 參賽辦法
              </Link>
              <div className="pf-mobile_menu-item-divider" />
              <Link
                to={joinUrl}
                className={classnames({
                  'pf-mobile_menu-item': true,
                  'pf-mobile_menu-item-hover':
                    window.location.href.indexOf(joinUrl) !== -1,
                })}
                style={{borderBottom: 'none'}}
                onClick={() => setShowMenu(false)}
              >
                <img alt="" src={joinIcon} />
                我要參賽
              </Link>
              <div className="pf-mobile_menu-item-divider" />
              <Link
                to={galleryUrl}
                className={classnames({
                  'pf-mobile_menu-item': true,
                  'pf-mobile_menu-item-hover':
                    window.location.href.indexOf(galleryUrl) !== -1,
                })}
                style={{borderBottom: 'none'}}
                onClick={() => setShowMenu(false)}
              >
                <img alt="" src={galleryIcon} />
                入圍作品
              </Link>
              <div className="pf-mobile_menu-item-divider" />
              <Link
                to={winnerUrl}
                className={classnames({
                  'pf-mobile_menu-item': true,
                  'pf-mobile_menu-item-hover':
                    window.location.href.indexOf(winnerUrl) !== -1,
                })}
                style={{borderBottom: 'none'}}
                onClick={() => setShowMenu(false)}
              >
                <img alt="" src={winnerIcon} />
                得獎作品
              </Link>
            </div>
          </div>
          <div className="pf-mobile_menu" />
        </div>
      )}
    </div>
  );
}
